import {Component, OnInit, ViewChild} from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {AzureAuthenticationApiService} from '../../../services/api/settings/administration/azure-authentication/azure-authentication-api.service';
import * as _ from 'lodash';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {RoleTypeEnum} from '../../../services/enums/role-type.enum';


@Component({
  selector: 'azure-authentication',
  templateUrl: './azure-authentication.component.html',
  styleUrls: ['./azure-authentication.component.scss'],
})
export class AzureAuthenticationComponent implements OnInit {

  @ViewChild('tooltip', {static: true}) tooltip;

  canSubmit: boolean;
  testResult = '';

  azureAuthentication: any = {testConnectivity: {}};

  constructor(
    private userPrivilege: UserPrivilegeService,
    private azureAuthenticationApiService: AzureAuthenticationApiService,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized(RoleTypeEnum.SECURITY_ADMIN);
    this.loaderService.showMainContainer();
    this.initialization();
  }

  submit(): void {
    const azureAuthentication = _.cloneDeep(this.azureAuthentication);
    azureAuthentication.clientSecret = _.isNil(azureAuthentication.clientSecret) ? null : azureAuthentication.clientSecret;

    this.azureAuthenticationApiService.updateAuthenticationAzureConfiguration(azureAuthentication).subscribe(() => {});
  }

  testServerConnectivity(): void {
    const parameters = _.cloneDeep(this.azureAuthentication);

    this.azureAuthenticationApiService.testAuthenticationAzureConfiguration(parameters).subscribe(data => {
      this.testResult = data.connectionStatus;
    }, (fail) => {
      this.testResult = 'Failed: ' + fail.error.description;
    });
  }

  initialization(): void {
    this.azureAuthenticationApiService.getAuthenticationAzureConfiguration().subscribe(azureAuthentication => {
      this.azureAuthentication = azureAuthentication;
      this.loaderService.hideMainContainer();
    });
  }

  copyMachineIdToClipboard(): void {
    this.tooltip.message = 'Copied';
    setTimeout(() => { this.tooltip.show(); }, 0);
  }

  mouseEnterCopyToClipboard(): void {
    this.tooltip.message = 'Copy to clipboard';
  }
}
